import React from 'react';
import { StyledChipContainer } from './Chip.styles';

export interface ChipProps {
  value: string;
  dataQaId?: string;
}

const Chip: React.FC<ChipProps> = ({ value, dataQaId }: ChipProps) => {
  return <StyledChipContainer data-qa-id={`${dataQaId}`}>{value || 'Chip'}</StyledChipContainer>;
};

export default Chip;
